/* @flow @format */

import $ from 'jquery';
import { type ContextRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as L from 'partial.lenses';
import React from 'react';

import { ProcQuizView, SoundContext } from '@sonyged/ext-proc';

import type { Contest } from '../../redux/reducer/entities';
import type { ContestType, Dispatch, StoreState } from '../../redux/types';
import { finishActivityBegin } from '../../redux/reducer/activity';
import { progressUpdated } from '../../redux/reducer/progresses';
import { selectBook, selectProgress } from '../../redux/selector';
import AppContext from '../../AppContext';
import api from '../../graphql/api';

export type MissionPageOwnProps = {|
  ...ContextRouter,
  contest: Contest,
  contestType: ContestType,
  course: any,
|};

type Props = {
  ...MissionPageOwnProps,
  book: any,
  muted: boolean,
  progress: number,
  progressUpdated: typeof progressUpdated,
  finishActivityBegin: typeof finishActivityBegin,
};

class MissionPageContainer extends React.Component<Props> {
  static contextType = AppContext;

  componentDidMount() {
    const {
      match: { params },
      progress,
      progressUpdated,
      history,
      course,
      contest,
      finishActivityBegin,
      contestType,
    } = this.props;

    const nextUrl = course.isDefault ? `/${contestType}/courses` : `/${contestType}/courses/${course.uid}`;

    const courseContentUid = L.get(['courseContents', 0, 'uid'], course);
    if (!courseContentUid) throw new Error('Unknown uid');

    api.checkoutActivity({ courseContentUid });

    const id = parseInt(params.id, 10);

    $(document).on('click', '.proc-btn.finish, .proc-button.finish', () => {
      if (id > progress) progressUpdated({ contestUid: contest.uid, courseUid: course.uid, progress: id });

      finishActivityBegin({ courseContentUid });
      history.push(`${nextUrl}#${id + 1}`);
    });

    $(document).on('click', '.proc-btn.quit, .proc-button.quit', () => {
      finishActivityBegin({ courseContentUid });
      history.push(`${nextUrl}#${id}`);
    });
  }

  componentWillUnmount() {
    $(document).off('click', '.proc-btn.finish, .proc-button.finish');
    $(document).off('click', '.proc-btn.quit, .proc-button.quit');
  }

  render() {
    const {
      match: { params },
      book,
    } = this.props;

    const id = parseInt(params.id, 10);
    const quiz = book.quizzes[id - 1];

    const sound = {
      muted: this.props.muted,
      sePlay: this.context.soundController.sePlay.bind(this.context.soundController),
      bgmPlay: this.context.soundController.bgmPlay.bind(this.context.soundController),
    };

    return (
      <div className="proc-courses-index-page">
        <SoundContext.Provider value={sound}>
          <ProcQuizView lang="ja" quiz={quiz} />
        </SoundContext.Provider>
      </div>
    );
  }
}

const mapStateToProps = (state: StoreState, { contest, course }: MissionPageOwnProps) => {
  const courseContentUid = L.get(['courseContents', 0, 'uid'], course);
  const book = selectBook(state, courseContentUid);
  const progress = selectProgress(state, contest.uid, course.uid);

  return {
    book,
    muted: state.config.mute,
    progress,
  };
};

const mapDispatchToProps = (dispatch: Dispatch, _: MissionPageOwnProps) => ({
  ...bindActionCreators({ progressUpdated, finishActivityBegin }, dispatch),
});

export default connect<Props, MissionPageOwnProps, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(MissionPageContainer);
